// constants/paymentFees.ts — Biaya transaksi per metode pembayaran (INFO saja).
// SUMBER NILAI: dashboard Duitku (Merchant Panel > Payment Method > "Biaya
// Layanan" + "Pembebanan Biaya"). SINKRON MANUAL tiap tarif Duitku berubah.
// INFO-ONLY: TIDAK mengubah total/CTA maupun nominal ke gateway — Duitku
// menambahkan fee sendiri untuk channel dengan Pembebanan = Customer.

export type FeeBearer = 'merchant' | 'customer';

export interface PaymentFee {
  /** Biaya flat (Rp). 0 = tanpa komponen flat. */
  flat: number;
  /** Biaya persen (%). 0 = tanpa komponen persen. */
  percent: number;
  /** Siapa yang menanggung biaya. */
  bearer: FeeBearer;
}

export const PAYMENT_FEES: Record<string, PaymentFee> = {
  'Duitku QRIS': { flat: 0, percent: 0.7, bearer: 'merchant' },
  'Duitku Mandiri Virtual Account': { flat: 4000, percent: 0, bearer: 'customer' },
  'Duitku BRI Virtual Account': { flat: 3000, percent: 0, bearer: 'customer' },
  'Duitku BNI Virtual Account': { flat: 3000, percent: 0, bearer: 'customer' },
  'Duitku Permata Virtual Account': { flat: 3000, percent: 0, bearer: 'customer' },
  'Duitku CIMB Niaga Virtual Account': { flat: 3000, percent: 0, bearer: 'customer' },
  'Duitku OVO': { flat: 0, percent: 1.65, bearer: 'customer' },
  'Duitku DANA': { flat: 0, percent: 1.67, bearer: 'customer' },
  'Duitku ShopeePay': { flat: 0, percent: 1.5, bearer: 'customer' },
  'Duitku LinkAja': { flat: 3330, percent: 0, bearer: 'customer' },
  'Duitku Kartu Kredit': { flat: 2500, percent: 2.9, bearer: 'customer' },
};

export function getPaymentFee(method?: string | null): PaymentFee | null {
  if (!method) return null;
  return PAYMENT_FEES[method] || null;
}

/** Label biaya: "Tanpa biaya" | "+Rp4.000" | "+Rp2.500 + 2,9%" | null (tak ada data). */
export function paymentFeeLabel(method?: string | null): string | null {
  const fee = getPaymentFee(method);
  if (!fee) return null;
  if (fee.bearer === 'merchant') return 'Tanpa biaya';
  const parts: string[] = [];
  if (fee.flat > 0) parts.push(`Rp${fee.flat.toLocaleString('id-ID')}`);
  if (fee.percent > 0) parts.push(`${fee.percent.toLocaleString('id-ID')}%`);
  return parts.length ? `+${parts.join(' + ')}` : 'Tanpa biaya';
}
